export default __webpack_public_path__ + "static/media/icons8-menu.60159947.svg";